<template>
  <div>
    <el-select
      v-model="operateData"
      placeholder="请选择账户"
      style="width: 100%"
      @change="changeOperate(operateData)"
    >
      <el-option
        v-for="item in operateOptions"
        :key="item.cid"
        :label="item.name + '(' + item.order + ')' + '余额:' + item.use"
        :value="item.cid"
      >
      </el-option>
    </el-select>
    <el-tabs
      type="border-card"
      stretch
      v-model="tabsName"
      @tab-click="handleClick"
    >
      <el-tab-pane label="开仓" name="buyStock">
        <el-row :gutter="10">
          <el-col :span="14">
            <el-form label-width="0" :model="stockBuy" size="medium">
              <el-form-item>
                <el-select
                  v-model="stockBuy.info"
                  filterable
                  remote
                  :remote-method="remoteMethod"
                  :loading="loading"
                  placeholder="代码/名称/简拼"
                  @change="changeInfo('buy', true);openDetailed($event)"
                  size="small"
                  class="full_width"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.short"
                    :label="item.name + ' ' + item.short"
                    :value="item.short"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="margin-bottom: 0">
                <el-row>
                  <el-col :span="8">
                    <el-button
                      type="danger"
                      @click="changePrice('buy')"
                      v-if="changeBuyType"
                      size="small"
                      class="full_width"
                      >市价</el-button
                    >
                    <el-button
                      type="danger"
                      @click="changePrice('buy')"
                      v-else
                      size="small"
                      class="full_width"
                      >限价</el-button
                    >
                  </el-col>
                  <el-col :span="16">
                    <el-input
                      :disabled="true"
                      v-if="changeBuyType"
                      size="small"
                      class="full_width"
                      placeholder="市价"
                    ></el-input>
                    <el-input
                      v-model="stockBuy.limitPrice"
                      v-else
                      size="small"
                      class="full_width"
                      placeholder="价格"
                    ></el-input>
                  </el-col>
                </el-row>
                <p>
                  涨停价:<span class="red">{{ stockBuy.hardenPrice }}</span
                  >&nbsp;&nbsp;&nbsp;跌停价:<span class="red">{{
                    stockBuy.dropPrice
                  }}</span>
                </p>
              </el-form-item>
              <el-form-item style="margin-bottom: 0">
                <el-input
                  v-model="stockBuy.number"
                  size="small"
                  type="number"
                  placeholder="数量"
                ></el-input>
                <p v-if="changeBuyType">
                  可开<span class="red">{{ buyMarketPrice }}</span
                  >股
                </p>
                <p v-else>
                  可开<span class="red">{{ buyLimitPrice }}</span
                  >股
                </p>
              </el-form-item>
              <el-form-item>
                <el-row>
                  <el-col :span="6">
                    <el-button
                      class="full_width"
                      size="small"
                      @click="position('buyFull')"
                      >全仓</el-button
                    >
                  </el-col>
                  <el-col :span="6">
                    <el-button
                      class="full_width"
                      size="small"
                      @click="position('buyThreeFourths')"
                      >3/4</el-button
                    >
                  </el-col>
                  <el-col :span="6">
                    <el-button
                      class="full_width"
                      size="small"
                      @click="position('buyTwoFourths')"
                      >1/2</el-button
                    >
                  </el-col>
                  <el-col :span="6">
                    <el-button
                      class="full_width"
                      size="small"
                      @click="position('buyOneFourths')"
                      >1/4</el-button
                    >
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label-width="0">
                <el-button type="danger submit" size="small" @click="buyStock"
                  >做多开仓</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="10">
            <el-card class="box-card" shadow="never">
              <el-row>
                <div
                  class="center box-market"
                  v-for="(item, index) in stockBuy.sellArr"
                  :key="index"
                >
                  <el-col :span="8">{{ item.id }}</el-col>
                  <el-col :span="8">{{ item.price }}</el-col>
                  <el-col :span="8">{{ item.number }}</el-col>
                </div>
              </el-row>
            </el-card>
            <el-card class="box-card" shadow="never" style="margin-top: 10px">
              <el-row>
                <p
                  class="center box-market"
                  v-for="(item, index) in stockBuy.buyArr"
                  :key="index"
                >
                  <el-col :span="8">{{ item.id }}</el-col>
                  <el-col :span="8">{{ item.price }}</el-col>
                  <el-col :span="8">{{ item.number }}</el-col>
                </p>
              </el-row>
            </el-card>
          </el-col>
          <el-col :span="24">
            <el-table
              :data="holdData"
              stripe
              height="240px"
              @row-click="buyHanddle"
              size="small"
              style="width: 100%"
            >
              <el-table-column label="名称/市值" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.name }}</p>
                    <p class="green">{{ scope.row.market }}</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.name }}</p>
                    <p class="red">{{ scope.row.market }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="持仓/可用" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.number }}</p>
                    <p class="green">{{ scope.row.sellable }}</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.number }}</p>
                    <p class="red">{{ scope.row.sellable }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="现价/均价" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.newPrice }}</p>
                    <p class="green">{{ scope.row.price }}</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.newPrice }}</p>
                    <p class="red">{{ scope.row.price }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="总盈亏" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.profitMarket }}</p>
                    <p class="green">{{ scope.row.priceRatio }}%</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.profitMarket }}</p>
                    <p class="red">{{ scope.row.priceRatio }}%</p>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="平仓" name="sellStock">
        <el-row :gutter="10">
          <el-col :span="14">
            <el-form :model="stockSell" size="medium">
              <el-form-item>
                <el-select
                  v-model="stockSell.info"
                  filterable
                  remote
                  :remote-method="remoteMethod"
                  :loading="loading"
                  placeholder="代码/名称"
                  @change="changeInfo('sell', true)"
                  size="small"
                  class="full_width"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.short"
                    :label="item.name + ' ' + item.short"
                    :value="item.short"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="margin-bottom: 0">
                <el-row>
                  <el-col :span="8">
                    <el-button
                      type="primary"
                      @click="changePrice('sell')"
                      v-if="changeSellType"
                      size="small"
                      class="full_width"
                      >市价</el-button
                    >
                    <el-button
                      type="primary"
                      @click="changePrice('sell')"
                      v-else
                      size="small"
                      class="full_width"
                      >限价</el-button
                    >
                  </el-col>
                  <el-col :span="16">
                    <el-input
                      v-if="changeSellType"
                      :disabled="true"
                      size="small"
                      class="full_width"
                      placeholder="市价"
                    ></el-input>
                    <el-input
                      v-model="stockSell.limitPrice"
                      v-else
                      size="small"
                      class="full_width"
                      placeholder="价格"
                    ></el-input>
                  </el-col>
                </el-row>
                <p>
                  涨停价:<span class="red">{{ stockSell.hardenPrice }}</span
                  >&nbsp;&nbsp;&nbsp;跌停价:<span class="red">{{
                    stockSell.dropPrice
                  }}</span>
                </p>
              </el-form-item>
              <el-form-item style="margin-bottom: 0">
                <el-input
                  v-model="stockSell.number"
                  size="small"
                  placeholder="数量"
                ></el-input>
                <p>
                  可平<span class="red">{{
                    parseInt(stockSell.validNumber)
                  }}</span
                  >股
                </p>
              </el-form-item>
              <el-form-item>
                <el-row>
                  <el-col :span="6">
                    <el-button
                      class="full_width"
                      size="small"
                      @click="position('sellFull')"
                      >全仓</el-button
                    >
                  </el-col>
                  <el-col :span="6">
                    <el-button
                      class="full_width"
                      size="small"
                      @click="position('sellThreeFourths')"
                      >3/4</el-button
                    >
                  </el-col>
                  <el-col :span="6">
                    <el-button
                      class="full_width"
                      size="small"
                      @click="position('sellTwoFourths')"
                      >1/2</el-button
                    >
                  </el-col>
                  <el-col :span="6">
                    <el-button
                      class="full_width"
                      size="small"
                      @click="position('sellOneFourths')"
                      >1/4</el-button
                    >
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label-width="0">
                <el-button type="primary submit" size="small" @click="sellStock"
                  >做多平仓</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="10">
            <el-card class="box-card" shadow="never">
              <el-row>
                <div
                  class="center box-market"
                  v-for="(item, index) in stockSell.sellArr" :key="index"
                >
                  <el-col :span="8">{{ item.id }}</el-col>
                  <el-col :span="8">{{ item.price }}</el-col>
                  <el-col :span="8">{{ item.number }}</el-col>
                </div>
              </el-row>
            </el-card>
            <el-card class="box-card" shadow="never" style="margin-top: 10px">
              <el-row>
                <p
                  class="center box-market"
                  v-for="(item, index) in stockSell.buyArr" :key="index"
                >
                  <el-col :span="8">{{ item.id }}</el-col>
                  <el-col :span="8">{{ item.price }}</el-col>
                  <el-col :span="8">{{ item.number }}</el-col>
                </p>
              </el-row>
            </el-card>
          </el-col>
          <el-col :span="24">
            <el-table
              :data="holdData"
              stripe
              height="240px"
              @row-click="sellHanddle"
              size="small"
              style="width: 100%"
            >
              <el-table-column label="名称/市值" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.name }}</p>
                    <p class="green">{{ scope.row.market }}</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.name }}</p>
                    <p class="red">{{ scope.row.market }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="持仓/可用" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.number }}</p>
                    <p class="green">{{ scope.row.sellable }}</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.number }}</p>
                    <p class="red">{{ scope.row.sellable }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="现价/均价" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.priceRatio.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.newPrice }}</p>
                    <p class="green">{{ scope.row.price }}</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.newPrice }}</p>
                    <p class="red">{{ scope.row.price }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="总盈亏" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.profitMarket }}</p>
                    <p class="green">{{ scope.row.priceRatio }}%</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.profitMarket }}</p>
                    <p class="red">{{ scope.row.priceRatio }}%</p>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="撤单" name="canceStock">
        <el-table
          :data="cancelData"
          height="560px"
          size="small"
          stripe
          style="width: 100%"
        >
          <el-table-column label="股票/时间" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.name }}</p>
              <p>{{ scope.row.accurate }}</p>
            </template>
          </el-table-column>
          <el-table-column label="委托价" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.deal }}</p>
            </template>
          </el-table-column>
          <el-table-column label="委托/成交" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.number }}</p>
              <p>{{ scope.row.finish }}</p>
            </template>
          </el-table-column>
          <el-table-column label="业务/状态" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.type }}</p>
              <p>{{ scope.row.status }}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                @click="handleCance(scope.row)"
                >撤单</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="持仓" name="holdStock">
        <el-table
          height="560px"
          size="small"
          :data="holdData"
          stripe
          style="width: 100%"
          row-key="short"
          :reserve-expansion="true"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-row>
                  <el-col :span="8" class="center">
                    <el-button
                      type="primary"
                      size="small"
                      @click="holdBuy(props.row.short)"
                      >买入</el-button
                    >
                  </el-col>
                  <el-col :span="8" class="center">
                    <el-button
                      type="primary"
                      size="small"
                      @click="holdSell(props.row.short)"
                      >卖出</el-button
                    >
                  </el-col>
                  <el-col :span="8" class="center">
                    <el-button
                      type="primary"
                      size="small"
                      @click="marketGo(props.row.short)"
                      >行情</el-button
                    >
                  </el-col>
                </el-row>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column label="名称/市值">
            <template slot-scope="scope">
              <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                <p class="green">{{ scope.row.name }}</p>
                <p class="green">{{ scope.row.market }}</p>
              </div>
              <div v-else>
                <p class="red">{{ scope.row.name }}</p>
                <p class="red">{{ scope.row.market }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="持仓/可用">
            <template slot-scope="scope">
              <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                <p class="green">{{ scope.row.number }}</p>
                <p class="green">{{ scope.row.sellable }}</p>
              </div>
              <div v-else>
                <p class="red">{{ scope.row.number }}</p>
                <p class="red">{{ scope.row.sellable }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="现价/均价">
            <template slot-scope="scope">
              <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                <p class="green">{{ scope.row.newPrice }}</p>
                <p class="green">{{ scope.row.price }}</p>
              </div>
              <div v-else>
                <p class="red">{{ scope.row.newPrice }}</p>
                <p class="red">{{ scope.row.price }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="总盈亏">
            <template slot-scope="scope">
              <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                <p class="green">{{ scope.row.profitMarket }}</p>
                <p class="green">{{ scope.row.priceRatio }}%</p>
              </div>
              <div v-else>
                <p class="red">{{ scope.row.profitMarket }}</p>
                <p class="red">{{ scope.row.priceRatio }}%</p>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="查询">
        <el-tabs stretch>
          <el-tab-pane label="委托查询">
            <el-table
              size="small"
              height="505px"
              :data="entrustData"
              stripe
              style="width: 100%"
            >
              <el-table-column label="日期/时间" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.time }}</p>
                  <p>{{ scope.row.accurate }}&nbsp;</p>
                </template>
              </el-table-column>
              <el-table-column label="名称/代码" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                  <p>{{ scope.row.code }}</p>
                </template>
              </el-table-column>
              <el-table-column label="买卖/状态" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.type }}</p>
                  <p>{{ scope.row.status }}&nbsp;</p>
                </template>
              </el-table-column>
              <el-table-column label="委托/成交价" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.deal }}&nbsp;</p>
                  <p>{{ scope.row.price }}&nbsp;</p>
                </template>
              </el-table-column>
              <el-table-column label="委托/成交量" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.number }}&nbsp;</p>
                  <p>{{ scope.row.finish }}&nbsp;</p>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="成交记录">
            <el-table
              size="small"
              height="505px"
              :data="dealData"
              stripe
              style="width: 100%"
            >
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-form label-position="right" size="mini">
                    <el-form-item label="日期时间">
                      <p class="right">
                        {{ props.row.time }} {{ props.row.accurate }}
                      </p>
                    </el-form-item>
                    <el-form-item label="业务名称">
                      <p class="right">{{ props.row.type }}</p>
                    </el-form-item>
                    <el-form-item label="股票代码">
                      <p class="right">
                        {{ props.row.name }} {{ props.row.code }}
                      </p>
                    </el-form-item>
                    <el-form-item label="成交数量">
                      <p class="right">{{ props.row.number }}</p>
                    </el-form-item>
                    <el-form-item label="成交价格">
                      <p class="right">{{ props.row.price }}</p>
                    </el-form-item>
                    <el-form-item label="成交金额">
                      <p class="right">{{ props.row.total }}</p>
                    </el-form-item>
                    <el-form-item label="券商佣金">
                      <p class="right">{{ props.row.commission }}</p>
                    </el-form-item>
                    <!-- fee change -->
                    <el-form-item label="过户费" v-if="props.row.short && props.row.short.startsWith('sh')"> 
                      <p class="right">{{ props.row.change }}</p>
                    </el-form-item>
                    <el-form-item label="经手费" v-if="props.row.short && props.row.short.startsWith('sh')">
                      <p class="right">{{ props.row.handle }}</p>
                    </el-form-item>
                    <el-form-item label="规费" v-if="props.row.short && props.row.short.startsWith('sz')">
                      <p class="right">{{ props.row.regular }}</p>
                    </el-form-item>
                    <el-form-item label="印花税">
                      <p class="right">{{ props.row.stamp }}</p>
                    </el-form-item>
                    <el-form-item label="产品处理费">
                      <p class="right">{{ props.row.extra_fee1 }}</p>
                    </el-form-item>
                    <el-form-item label="结算费用">
                      <p class="right">{{ props.row.extra_fee2 }}</p>
                    </el-form-item>
                    <el-form-item label="平台费用">
                      <p class="right">{{ props.row.extra_fee3 }}</p>
                    </el-form-item>
                    <el-form-item label="总金额">
                      <p class="right">{{ props.row.totalplus }}</p>
                    </el-form-item>
                  </el-form>
                </template>
              </el-table-column>
              <el-table-column label="日期/时间" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.time }}</p>
                  <p>{{ scope.row.accurate }}</p>
                </template>
              </el-table-column>
              <el-table-column label="名称/代码" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                  <p>{{ scope.row.code }}</p>
                </template>
              </el-table-column>
              <el-table-column label="买卖/数量" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.type }}</p>
                  <p>{{ scope.row.number }}</p>
                </template>
              </el-table-column>
              <el-table-column label="单价/总价" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.price }}</p>
                  <p>{{ scope.row.total }}</p>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="系统平仓">
            <el-table
              size="small"
              height="505px"
              :data="unwindData"
              stripe
              style="width: 100%"
            >
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-form label-position="right" size="mini">
                    <el-form-item label="日期时间">
                      <p class="right">
                        {{ props.row.time }} {{ props.row.accurate }}
                      </p>
                    </el-form-item>
                    <el-form-item label="业务名称">
                      <p class="right">{{ props.row.type }}</p>
                    </el-form-item>
                    <el-form-item label="股票代码">
                      <p class="right">
                        {{ props.row.name }} {{ props.row.code }}
                      </p>
                    </el-form-item>
                    <el-form-item label="成交数量">
                      <p class="right">{{ props.row.number }}</p>
                    </el-form-item>
                    <el-form-item label="成交价格">
                      <p class="right">{{ props.row.price }}</p>
                    </el-form-item>
                    <el-form-item label="券商佣金">
                      <p class="right">{{ props.row.commission }}</p>
                    </el-form-item>
                    <!-- fee change -->
                    <el-form-item label="过户费" v-if="props.row.short && props.row.short.startsWith('sh')"> 
                      <p class="right">{{ props.row.change }}</p>
                    </el-form-item>
                    <el-form-item label="经手费" v-if="props.row.short && props.row.short.startsWith('sh')">
                      <p class="right">{{ props.row.handle }}</p>
                    </el-form-item>
                    <el-form-item label="规费" v-if="props.row.short && props.row.short.startsWith('sz')">
                      <p class="right">{{ props.row.regular }}</p>
                    </el-form-item>
                    <el-form-item label="印花税">
                      <p class="right">{{ props.row.stamp }}</p>
                    </el-form-item>
                    <el-form-item label="总金额">
                      <p class="right">{{ props.row.total }}</p>
                    </el-form-item>
                  </el-form>
                </template>
              </el-table-column>
              <el-table-column label="日期/时间" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.time }}</p>
                  <p>{{ scope.row.accurate }}</p>
                </template>
              </el-table-column>
              <el-table-column label="名称/代码" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                  <p>{{ scope.row.code }}</p>
                </template>
              </el-table-column>
              <el-table-column label="买卖/数量" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.type }}</p>
                  <p>{{ scope.row.number }}</p>
                </template>
              </el-table-column>
              <el-table-column label="单价/总价" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.price }}</p>
                  <p>{{ scope.row.total }}</p>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="对账单">
            <el-table
              height="505px"
              size="small"
              :data="capitalData"
              stripe
              style="width: 100%"
            >
              <el-table-column label="日期" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.time }}</p>
                  <p>{{ scope.row.accurate }}</p>
                </template>
              </el-table-column>
              <el-table-column label="名称/类型" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                  <p>{{ scope.row.type }}</p>
                </template>
              </el-table-column>
              <el-table-column label="金额/余额" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.number }}</p>
                  <p>{{ scope.row.balance }}</p>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
    <!-- ============================== Start change channel popup ========================== -->
    <el-dialog
      :visible.sync="showTradeChannelPopup"
      width="40%"
      center
      custom-class="tradingChannelPop"
    >
      <div v-html="trade_rules_content_top"></div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="agreeTradeRules()"
          style="background: #ff0000; border-color: #ff0000; width: 200px"
          >我已经明白
        </el-button>
        <div
          v-html="trade_rules_content_bottom"
          style="padding-top: 10px"
        ></div>
      </span>
    </el-dialog>
    <!-- ============================== end change channel popup ========================== -->
  </div>
</template>

<script>
import $ from "jquery";
import eventBus from "../assets/js/eventBus";

export default {
  name: "stocktrading",
  data() {
    return {
      tabsName: "buyStock",
      //股票买入
      stockBuy: {
        info: "",
        marketPrice: "", //市价
        limitPrice: "", //现价
        hardenPrice: 0, //涨停
        dropPrice: 0, //跌停
        number: "",
        buyArr: [
          {
            id: "买1",
            price: "- -",
            number: "- -",
          },
          {
            id: "买2",
            price: "- -",
            number: "- -",
          },
          {
            id: "买3",
            price: "- -",
            number: "- -",
          },
          {
            id: "买4",
            price: "- -",
            number: "- -",
          },
          {
            id: "买5",
            price: "- -",
            number: "- -",
          },
        ], //五档行情
        sellArr: [
          {
            id: "卖5",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖4",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖3",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖2",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖1",
            price: "- -",
            number: "- -",
          },
        ],
      },
      //股票卖出
      stockSell: {
        info: "",
        marketPrice: "", //市价
        limitPrice: "", //现价
        hardenPrice: 0, //涨停
        dropPrice: 0, //跌停
        number: "",
        buyArr: [
          {
            id: "买1",
            price: "- -",
            number: "- -",
          },
          {
            id: "买2",
            price: "- -",
            number: "- -",
          },
          {
            id: "买3",
            price: "- -",
            number: "- -",
          },
          {
            id: "买4",
            price: "- -",
            number: "- -",
          },
          {
            id: "买5",
            price: "- -",
            number: "- -",
          },
        ], //五档行情
        sellArr: [
          {
            id: "卖5",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖4",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖3",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖2",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖1",
            price: "- -",
            number: "- -",
          },
        ],
        validNumber: 0,
      },
      //撤单
      cancelData: [],
      //持仓
      holdData: [],
      //委托
      entrustData: [],
      //成交
      dealData: [],
      //账户信息
      operateOptions: [],
      //选中账户
      operateData: "",
      //流水资金
      capitalData: [],
      //修改市价限价
      changeBuyType: true,
      changeSellType: true,
      //用户可用余额
      UserAvailable: 0,
      //远程搜索
      loading: false,
      options: [],
      transmitCid: 0,
      unwindData: [],
      showTradeChannelPopup: false,
      trade_rules_content_top: "",
      trade_rules_content_bottom: "",
       tradeDirection: this.$route.query.direction,
       addBondMoney: "",
       addMoney: "",
       bond :0,
    };
  },
  computed: {
    //下拉框数据
    restaurants: function () {
      return this.$store.state.restaurants;
    },
    //买入市价计算
    buyMarketPrice: function () {
      let that = this;
      let marketPrice = parseInt(
        Number(that.UserAvailable) / Number(that.stockBuy.marketPrice)
      );
      if (isNaN(marketPrice) || marketPrice < 0 ) {
        return 0;
      } else {
        return marketPrice;
      }
    },
    //买入限价计算
    buyLimitPrice: function () {
      let that = this;
      let limitPrice = parseInt(
        Number(that.UserAvailable) / Number(that.stockBuy.limitPrice)
      );
      if (isNaN(limitPrice)) {
        return 0;
      } else {
        return limitPrice;
      }
    },
  },
  methods: {
    //获取持仓信息
    getHoldData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "depot_stock",
            token: window.sessionStorage.getItem("token"),
            cid: that.operateData,
            direction: 0
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            var dataArr = res.data.data;
            var shortArr = [];
            if (dataArr.length != 0) {
              $.each(dataArr, function (index, item) {
                shortArr.push(item.short);
              });
              that.getNewPrice(shortArr, dataArr);
              clearInterval(window.timer1);
              window.timer1 = setInterval(function () {
                that.getNewPrice(shortArr, dataArr);
              }, 1000);
            } else {
              clearInterval(window.timer1);
              that.holdData = dataArr;
            }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    openDetailed(event){
      let that = this;
      eventBus.$emit("state", event.trim());
      eventBus.$emit("symbol", event.trim());
      this.$router.push({ name: 'Stockdetailed', query: { symbol:event.trim(), direction:that.tradeDirection }});
    },
    //请求当前价 计算 盈亏  盈亏比例
    getNewPrice(shortArr, dataArr) {
      let that = this;
      $.ajax({
        url: "https://qt.gtimg.cn/q=" + shortArr.toString(),
        type: "GET",
        dataType: "script",
        cache: true,
        success: function () {
          var i, elements;
          for (i = 0; i < shortArr.length; i++) {
            var elements = eval("v_" + shortArr[i]).split("~");
            dataArr[i]["newPrice"] = elements[3]; //当前价
            var newPrice = parseFloat(elements[3]); //当前价
            // dataArr[i]["newPrice"] = elements[9]; //当前价
            // var newPrice = parseFloat(elements[9]); //当前价
            var number = parseFloat(dataArr[i].number); //持有股数
            var costPrice = parseFloat(dataArr[i].price); //成本价
            var profitPrice = Number((newPrice - costPrice).toFixed(2)); //盈亏金额
            var priceRatio = ((newPrice - costPrice) / costPrice) * 100; //盈亏比例
            var market = (newPrice * number).toFixed(2); //当前市值
            let profitMarket = ((newPrice -dataArr[i].price) *dataArr[i].number ).toFixed(2); 
            priceRatio = priceRatio.toFixed(2);
            dataArr[i]["profitPrice"] = profitPrice;
            dataArr[i]["priceRatio"] = priceRatio;
            dataArr[i]["market"] = market;
            dataArr[i]["profitMarket"] = profitMarket;
          }
          that.holdData = dataArr;
        },
      });
    },
    //获取全部委托信息
    getEntrustData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "entrust_log",
            token: window.sessionStorage.getItem("token"),
            cid: that.operateData,
            direction: 0
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            let entrustData = res.data.data;
            for (let i = 0, len = entrustData.length; i < len; i++) {
              if (Number(entrustData[i].deal) === 0) {
                entrustData[i].deal = "--";
              }
              if (Number(entrustData[i].price) === 0) {
                entrustData[i].price = "--";
              }
            }
            that.entrustData = entrustData;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //获取全部成交订单
    getDealData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "deal_log",
            token: window.sessionStorage.getItem("token"),
            cid: that.operateData,
            direction: 0
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            let dealData = res.data.data;
            let unwindData = [];
            for (let i = 0, len = dealData.length; i < len; i++) {
              if (dealData[i].depot_mold === 1) {
                unwindData.push(dealData[i]);
              }
            }
            that.unwindData = unwindData;
            that.dealData = dealData;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //获取全部撤单
    getCancelData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "cancel_order",
            token: window.sessionStorage.getItem("token"),
            cid: that.operateData,
            direction: 0
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            that.cancelData = res.data.data;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //获取账户号
    getOperate() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "current_operate",
            token: window.sessionStorage.getItem("token"),
            direction: 0
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            that.operateOptions = res.data.data .filter(item => item.direction_capital!=1);
            if (that.$route.query.cid !== undefined && that.$route.query.cid !== null && that.$route.query.cid !== '') {
              that.operateData = parseInt(that.$route.query.cid);
            } else {
              if (that.operateData == null || that.operateData === "") {
                that.operateData = that.operateOptions[0].cid;
              }
            }
             // Step 2: check if operateData exists in operateOptions
             const exists = that.operateOptions.some(item => item.cid == that.operateData);
 
             // Step 3: fallback if not exists OR empty
             if (!exists) {
               if (that.operateOptions.length > 0) {
                 that.operateData = that.operateOptions[0].cid;
               } else {
                 that.operateData = null; // or handle empty case
               }
             }
            that.changeOperate();
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //获取用户子账户可用余额
    getUserAvailable() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "current_detailed",
            token: window.sessionStorage.getItem("token"),
            cid: that.operateData,
            direction: 0
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            that.UserAvailable = res.data.data.available;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //更改账户
    changeOperate(cid) {
      let that = this;
      // that.$route.query.cid = that.operateData;
      clearInterval(window.holdTimer);
          window.holdTimer = setInterval(() => {
               that.getHoldData();
        }, 2000);
      that.getEntrustData();
      that.getDealData();
      that.getCancelData();
      that.getCapitalData();
      that.getUserAvailable();
    },
    //获取资金流水
    getCapitalData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "capital_log",
            token: window.sessionStorage.getItem("token"),
            cid: that.operateData,
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            let capitalData = res.data.data;
            for (let i = 0, len = capitalData.length; i < len; i++) {
               const parts = String(capitalData[i].time).split(" ");
               capitalData[i].time = parts[0] || "";
               capitalData[i].accurate = parts[1] || "";
            }
            that.capitalData = capitalData;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //修改市价限价
    changePrice(deal) {
      let that = this;
      if (deal === "buy") {
        that.changeBuyType
          ? (that.changeBuyType = false)
          : (that.changeBuyType = true);
        that.changeBuyType
          ? ""
          : (that.stockBuy.limitPrice = that.stockBuy.marketPrice);
      } else if (deal === "sell") {
        that.changeSellType
          ? (that.changeSellType = false)
          : (that.changeSellType = true);
        that.changeSellType
          ? ""
          : (that.stockSell.limitPrice = that.stockSell.marketPrice);
      }
    },
    //修改股票信息
    //pass optional paramater changeLimitPrice to change the limit price value in the input
    changeInfo(deal, changeLimitPrice = false) {
      let that = this;
      if (deal === "buy") {
        $.ajax({
          url: "https://qt.gtimg.cn/q=" + that.stockBuy.info.toString(),
          type: "GET",
          dataType: "script",
          cache: true,
          success: function () {
            let elements = eval("v_" + that.stockBuy.info).split("~");
            $.each(that.stockBuy.buyArr, function (index, item) {
              item.price = elements[index * 2 + 9];
              item.number = elements[index * 2 + 10];
            });
            $.each(that.stockBuy.sellArr, function (index, item) {
              item.price = elements[27 - index * 2];
              item.number = elements[28 - index * 2];
            });
            that.stockBuy.marketPrice = elements[3];//that.stockBuy.sellArr[4].price;
            if (changeLimitPrice)
              that.stockBuy.limitPrice = that.stockBuy.sellArr[4].price;
            // that.stockBuy.limitPrice =  that.stockBuy.sellArr[4].price;
            that.stockBuy.hardenPrice = elements[47];
            that.stockBuy.dropPrice = elements[48];
          },
        });
        clearInterval(window.timer3);
        window.timer3 = setInterval(function () {
          that.changeInfo("buy");
        }, 1000);
      } else if (deal === "sell") {
        $.ajax({
          url: "https://qt.gtimg.cn/q=" + that.stockSell.info.toString(),
          type: "GET",
          dataType: "script",
          cache: true,
          success: function () {
            let elements = eval("v_" + that.stockSell.info).split("~");
            $.each(that.stockSell.buyArr, function (index, item) {
              item.price = elements[index * 2 + 9];
              item.number = elements[index * 2 + 10];
            });
            $.each(that.stockSell.sellArr, function (index, item) {
              item.price = elements[27 - index * 2];
              item.number = elements[28 - index * 2];
            });
            that.stockSell.marketPrice = elements[3];//that.stockSell.buyArr[0].price;
            if (changeLimitPrice)
              that.stockSell.limitPrice = that.stockSell.buyArr[0].price;
            // that.stockSell.limitPrice = that.stockSell.buyArr[0].price;
            that.stockSell.hardenPrice = elements[47];
            that.stockSell.dropPrice = elements[48];
          },
        });
        let sellable = 0;
        for (let i = 0, len = that.holdData.length; i < len; i++) {
          if (that.holdData[i].short.trim() === that.stockSell.info.trim()) {
            sellable = that.holdData[i].sellable;
          }
        }
        that.stockSell.validNumber = sellable;
        clearInterval(window.timer2);
        window.timer2 = setInterval(function () {
          that.changeInfo("sell");
        }, 1000);
      }
    },
    //快速选仓
    position(storehouse) {
      let that = this;
      switch (storehouse) {
        case "buyFull":
          if (that.changeBuyType) {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  Number(that.UserAvailable) / Number(that.stockBuy.marketPrice)
                ) / 100
              ) * 100;
          } else {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  Number(that.UserAvailable) / Number(that.stockBuy.limitPrice)
                ) / 100
              ) * 100;
          }
          break;
        case "buyThreeFourths":
          if (that.changeBuyType) {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  parseInt(
                    Number(that.UserAvailable) /
                      Number(that.stockBuy.marketPrice)
                  ) * 0.75
                ) / 100
              ) * 100;
          } else {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  parseInt(
                    Number(that.UserAvailable) /
                      Number(that.stockBuy.limitPrice)
                  ) * 0.75
                ) / 100
              ) * 100;
          }
          break;
        case "buyTwoFourths":
          if (that.changeBuyType) {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  parseInt(
                    Number(that.UserAvailable) /
                      Number(that.stockBuy.marketPrice)
                  ) * 0.5
                ) / 100
              ) * 100;
          } else {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  parseInt(
                    Number(that.UserAvailable) /
                      Number(that.stockBuy.limitPrice)
                  ) * 0.5
                ) / 100
              ) * 100;
          }
          break;
        case "buyOneFourths":
          if (that.changeBuyType) {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  parseInt(
                    Number(that.UserAvailable) /
                      Number(that.stockBuy.marketPrice)
                  ) * 0.25
                ) / 100
              ) * 100;
          } else {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  parseInt(
                    Number(that.UserAvailable) /
                      Number(that.stockBuy.limitPrice)
                  ) * 0.25
                ) / 100
              ) * 100;
          }
          break;
        case "sellFull":
          that.stockSell.number =
            parseInt(parseInt(that.stockSell.validNumber) / 100) * 100;
          break;
        case "sellThreeFourths":
          that.stockSell.number =
            parseInt(parseInt(that.stockSell.validNumber * 0.75) / 100) * 100;
          break;
        case "sellTwoFourths":
          that.stockSell.number =
            parseInt(parseInt(that.stockSell.validNumber * 0.5) / 100) * 100;
          break;
        case "sellOneFourths":
          that.stockSell.number =
            parseInt(parseInt(that.stockSell.validNumber * 0.25) / 100) * 100;
          break;
      }
    },
    remoteMethod(query) {
      let that = this;
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = that.restaurants.filter((item) => {
            return (
              item.name.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
              item.short.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
              item.pinyin.toLowerCase().indexOf(query.toLowerCase()) > -1
            );
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    //购买股票
    buyStock() {
      let token = window.sessionStorage.getItem("token");
      let that = this;
      let buyPrice = 0;
      let mold = 0;
      if (that.changeBuyType) {
        mold = 2;
        buyPrice = Number(that.stockBuy.marketPrice);
      } else {
        mold = 1;
        buyPrice = Number(that.stockBuy.limitPrice);
      }
      let buyCode = that.stockBuy.info.replace(/[^0-9]/gi, "");
      let buyNumber = parseInt(that.stockBuy.number);
      if (token === null) {
        this.$message.error({
          message: "您还未登录,请先去登录后在操作购买",
          onClose: function () {
            that.$router.push({ path: "/login" });
          },
        });
      } else if (buyCode === "" || isNaN(buyCode)) {
        this.$message.error({
          message: "您未选择股票",
        });
      } else if (buyNumber === "" || isNaN(buyNumber)) {
        this.$message.error({
          message: "您未选择购买数量",
        });
      } else {
        that
          .$confirm(
            // "以" +
            // buyPrice +
            // "元的价格买入" +
            // buyNumber +
            // "股, 是否继续?",
            // "买入股票",
            "您是否确定买入该股票?",
            "确认交易",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
          .then(() => {
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "buy_stock",
                  token: sessionStorage.getItem("token"),
                  cid: that.operateData,
                  code: buyCode,
                  number: buyNumber,
                  price: buyPrice,
                  mold: mold,
                  direction: 0
                },
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.$message({
                    message: res.data.msg,
                    type: "success",
                    duration: 1000,
                    onClose: function () {
                      that.getOperate();
                      that.stockBuy.number = "";
                    },
                  });
                } else if (res.data.code == 2) {
                  that.getTradeChannel();
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(res.data.msg);
                }
              });
          })
          .catch(() => {
            that.$message({
              type: "info",
              message: "已取消买入",
            });
          });
      }
    },
    //卖出股票
    sellStock() {
      let that = this;
      let holdFlag = false;
      for (let i = 0, len = that.holdData.length; i < len; i++) {
        if (that.holdData[i].short.trim() === that.stockSell.info.trim()) {
          holdFlag = true;
        }
      }

      let token = window.sessionStorage.getItem("token");

      let sellPrice = 0;

      let mold = 0;
      if (that.changeSellType) {
        mold = 2;
        sellPrice = Number(that.stockSell.marketPrice);
      } else {
        mold = 1;
        sellPrice = Number(that.stockSell.limitPrice);
      }
      let sellCode = that.stockSell.info.replace(/[^0-9]/gi, "");
      let sellNumber = parseInt(that.stockSell.number);

      if (token === null) {
        this.$message.error({
          message: "您还未登录,请先去登录后在操作卖出",
          onClose: function () {
            that.$router.push({ path: "/login" });
          },
        });
      } else if (!holdFlag) {
        that.stockSell.validNumber = 0;
        this.$message.error("还未购买此股票,请进入购买页面购买此股票");
      } else if (sellCode === "" || isNaN(sellCode)) {
        this.$message.error({
          message: "您未选择股票",
        });
      } else if (sellNumber === "" || isNaN(sellNumber)) {
        this.$message.error({
          message: "您未选择卖出数量",
        });
      } else {
        that
          .$confirm(
            // "以" +
            // sellPrice +
            // "的价格卖出" +
            // sellNumber +
            // "股, 是否继续?",
            // "卖出股票",
            "您是否确认卖出该股票?",
            "确认交易",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
          .then(() => {
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "sell_stock",
                  token: sessionStorage.getItem("token"),
                  cid: that.operateData,
                  code: sellCode,
                  number: sellNumber,
                  price: sellPrice,
                  mold: mold,
                  direction: 0
                },
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.$message({
                    message: res.data.msg,
                    type: "success",
                    duration: 1000,
                    onClose: function () {
                      that.getOperate();
                      that.stockSell.number = "";
                    },
                  });
                  /*that.$refs.child1.getStrategyInfo();
                      setTimeout(function() {
                        that.setNumber(that.maxNumber, that.ratio);
                        that.getHoldlist();
                        that.getInfo(that.short, 1);
                      }, 1000);*/
                } else if (res.data.code == 2) {
                  that.getTradeChannel();
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(res.data.msg);
                }
              });
          })
          .catch(() => {
            that.$message({
              type: "info",
              message: "已取消卖出入",
            });
          });
      }
    },
    // ============= get the content of trade channel popup agreement ===========
    getTradeChannel() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "trade_popup",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.trade_rules_content_top = res.data.data.content_top;
            that.trade_rules_content_bottom = res.data.data.content_bottom;
            that.showTradeChannelPopup = true;
          } else {
          }
        });
    },
    // ============================== Click agree the trade rules ========================
    agreeTradeRules() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modify_trade_status",
            token: sessionStorage.getItem("token"),
            trade_channel_status: 1,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$message({
              message: res.data.msg,
              type: "success",
              duration: 1000,
            });
            that.showTradeChannelPopup = false;
            that.trade_channel_status = 0;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //点击表格触发赋值
    buyHanddle(row, event, column) {
      let that = this;
      that.stockBuy.info = row.short;
      that.changeInfo("buy", true);
      that.remoteMethod(row.short);
      this.$router.push({ name: 'Stockdetailed', query: { symbol:row.short, direction:0 }});
    },
    //点击卖出表格触发
    sellHanddle(row, event, column) {
      let that = this;
      that.stockSell.info = row.short;
      that.stockSell.validNumber = row.sellable;
      that.changeInfo("sell", true);
      that.remoteMethod(row.short);
      this.$router.push({ name: 'Stockdetailed', query: { symbol:row.short, direction:0 }});
    },
    //持仓页面进入买入页面
    holdBuy(short) {
      let that = this;
      that.stockBuy.info = short;
      that.changeInfo("buy", true);
      that.remoteMethod(short);
      this.tabsName = "buyStock";
    },
    //持仓页面进入卖出页面
    holdSell(short) {
      let that = this;
      that.stockSell.info = short;
      that.changeInfo("sell", true);
      that.remoteMethod(short);
      this.tabsName = "sellStock";
    },
    //持仓页面进入行情页面
    marketGo(short) {
      let that = this;
      that.$router.push({ path: "/stockmarket/detailed?symbol=" + short + "&direction=0" });
    },
    //撤单
    handleCance(data) {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "cancel_entrust",
            token: sessionStorage.getItem("token"),
            cid: that.operateData,
            order: data.id,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$message({
              message: res.data.msg,
              type: "success",
              duration: 1000,
              onClose: function () {
                that.changeOperate();
              },
            });
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
    //时间格式数据
    timeTypeData(value) {
      let temp = [];
      for (let i = 0, len = value.length; i < len; i++) {
        if (!temp.includes(value[i].time)) {
          temp.push(value[i].time);
        }
      }
      for (let i = 0, len = temp.length; i < len; i++) {
        temp[i] = { index: i + 1, time: temp[i], children: [] };
        for (let j = 0, len1 = value.length; j < len1; j++) {
          if (temp[i].time === value[j].time) {
            value[j].index = parseInt((i + 1).toString() + (j + 1).toString());
            temp[i].children.push(value[j]);
          }
        }
      }
      return temp;
    },
    handleClick(tab, event) {
      let that = this;
      if (tab.name == "canceStock") {
        that.changeOperate();
      }
    },
  },
  mounted: function () {
    let that = this;
    if (this.$store.state.loginType) {
      this.getOperate();
    }
  },
  watch: {
    "stockBuy.limitPrice": {
      handler: function (value) {
        let that = this;
        var str = value;
        var len1 = str.substr(0, 1);
        var len2 = str.substr(1, 1);
        //如果第一位是0，第二位不是点，就用数字把点替换掉
        if (str.length > 1 && len1 == 0 && len2 != ".") {
          str = str.substr(1, 1);
        }
        //第一位不能是.
        if (len1 == ".") {
          str = "";
        }
        //限制只能输入一个小数点
        if (str.indexOf(".") != -1) {
          var str_ = str.substr(str.indexOf(".") + 1);
          if (str_.indexOf(".") != -1) {
            str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
          }
        }
        if (str.length > 10) {
          str = str.substring(0, 10);
        }

        //正则替换，保留数字和小数点
        // str = str.replace(/[^\d^\.]+/g,'');
        //如果需要保留小数点后两位，则用下面公式
        str = str.replace(/\.\d\d\d$/, "");
        that.stockBuy.limitPrice = str;
      },
    },
    "stockSell.limitPrice": {
      handler: function (value) {
        let that = this;
        var str = value;
        var len1 = str.substr(0, 1);
        var len2 = str.substr(1, 1);
        //如果第一位是0，第二位不是点，就用数字把点替换掉
        if (str.length > 1 && len1 == 0 && len2 != ".") {
          str = str.substr(1, 1);
        }
        //第一位不能是.
        if (len1 == ".") {
          str = "";
        }
        //限制只能输入一个小数点
        if (str.indexOf(".") != -1) {
          var str_ = str.substr(str.indexOf(".") + 1);
          if (str_.indexOf(".") != -1) {
            str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
          }
        }
        if (str.length > 10) {
          str = str.substring(0, 10);
        }
        //正则替换，保留数字和小数点
        // str = str.replace(/[^\d^\.]+/g,'');
        //如果需要保留小数点后两位，则用下面公式
        str = str.replace(/\.\d\d\d$/, "");
        that.stockSell.limitPrice = str;
      },
    },
     $route(to,from){
        if(this.tradeDirection != this.$route.query.direction){
          this.state = ''
        }
        this.tradeDirection = this.$route.query.direction
      },
  },
  created() {
    let that = this;
    eventBus.$on("symbol", (symbol) => {
      that.holdBuy(symbol);
    });
  },
  destroyed() {
    clearTimeout(window.timer1);
    clearTimeout(window.timer2);
    clearTimeout(window.timer3);
    clearTimeout(window.holdTimer);
  },
};
</script>
<style scoped>
.submit {
  width: 100%;
}
.green {
  color: #008000;
}
.full_width {
  width: 100%;
}
.box-market {
  overflow: hidden;
  font-size: 14px;
  line-height: 1.5;
}
.container {
  width: 100%;
  max-width: 1200px;
  min-width: 1400px;
  margin: 10px auto;
}
</style>
<style>
.tradingChannelPop .el-dialog__body {
  padding: 0px 20px;
}

/* .tradingChannelPop .el-dialog__header {
  display: none;
} */
</style>



// WEBPACK FOOTER //
// src/components/stocktrading.vue